import type { CoreOfficeDataType } from '~/types/offices';
import { currencyDisplay } from '~/components/utils/text';
import { useTranslation } from 'react-i18next';
import { getPricePerSeat, isFlexibilityFixed } from './utils';
import { TFunction } from 'i18next';
import Badge, { Variant } from '~/components/common/badges/Badge';
import SVGIcon from '~/components/ui/Icons/SVGIcon';
import mixpanelTrack from '~/hooks/useMixPanel';

declare var bootstrap: any;

type TProps = {
  office: CoreOfficeDataType;
  daysPerWeek: number;
  requiredCapacity: number;
  extraClasses?: string;
};

const PricePerSeatSection = ({ office, requiredCapacity, daysPerWeek, extraClasses }: TProps) => {
  const { t } = useTranslation();

  const discountLongTermPercent = Math.round(office.discountLongTermPercent || 0);
  const discountLastMinutePercent = Math.round(office.discountLastMinutePercent || 0);
  const totalDiscountAmount = Number(discountLastMinutePercent) + Number(discountLongTermPercent);

  const flexibilityFixed = isFlexibilityFixed(office.flexibility, office.partTimeDays);

  const openModal = () => {
    const modal = bootstrap.Modal.getOrCreateInstance('#ctaCardModal');
    modal?.show();
  };

  return (
    <div
      className={` d-flex justify-content-between align-items-center ${extraClasses}`}
      role="button"
      onClick={() => {
        mixpanelTrack('E.mobile_price_section_click');
        openModal();
      }}
    >
      <div>
        {(office.discountLastMinutePercent || office.discountLongTermPercent) && (
          <Badge
            extraClasses="mb-2"
            text={t('office.price.discount.discountApplicable', { amount: totalDiscountAmount })}
            variant={Variant.ERROR_LIGHT}
          />
        )}
        <div className="text-2 -regular text-decoration-underline">
          {getMonthlyPricePerSeatLabel(flexibilityFixed, daysPerWeek, t)}
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <span className="price-display">
            {currencyDisplay(getPricePerSeat(daysPerWeek, office, requiredCapacity), 0)}{' '}
          </span>
        </div>
      </div>
      <div>
        <SVGIcon
          iconType="chevron-right"
          width="40"
          height="40"
          fill="#706D78"
        />
      </div>
    </div>
  );
};

const getMonthlyPricePerSeatLabel = (flexibilityFixed: boolean, daysPerWeek: number, t: TFunction) => {
  if (flexibilityFixed) {
    return t('office.show.requestVisitCard.popover.pricePerSeat.label.flexibilityFixed');
  }
  return t('office.show.requestVisitCard.popover.pricePerSeat.label.flexibilityNotFixed', {
    days: daysPerWeek,
    dayPluralization: t('global.pluralization.i18next.day', { count: daysPerWeek }),
  });
};

export default PricePerSeatSection;
